import { render } from "./PinOffIcon.vue?vue&type=template&id=c2963a26"
import script from "./PinOffIcon.vue?vue&type=script&lang=js"
export * from "./PinOffIcon.vue?vue&type=script&lang=js"
script.render = render

export default script